module.exports = __webpack_public_path__ + "img/second_image_jiaxiao@2x.a494aa62.png";